import { create } from 'zustand';

import { localStorageUtil } from '../../utils/local-storage.util';

export const accessTokenLocalStorage = localStorageUtil<string>('accessToken');

type AccessTokenState = {
  delete: () => void;
  get: () => null | string;
  key: string;
  set: (value: string) => void;
  value: null | string;
};

export const accessTokenStorage = create<AccessTokenState>()((set, get) => {
  return {
    key: 'accessToken',
    value: accessTokenLocalStorage.get(),
    delete: () => {
      accessTokenLocalStorage.delete();
      set(() => ({ value: null }));
    },
    get: () => get().value,
    set: (newValue) => {
      accessTokenLocalStorage.set(newValue);
      set(() => ({ value: newValue }));
    },
  };
});
